import { connect } from 'react-redux'
import View from './I24NewsPlusLink'

// mapStateToProps :: State -> Props
const mapStateToProps = state => ({
  locale: state.router.locale,
})

// I24NewsPlusLink :: Props -> React.Component
const I24NewsPlusLink = connect(mapStateToProps)(View)

export default I24NewsPlusLink
